module.exports = __webpack_public_path__ + "static/img/img27.fc3b46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img27.png
// module id = PROz
// module chunks = 1